import { render } from "./NyuukaPlanPage.vue?vue&type=template&id=71082aca"
import script from "./NyuukaPlanPage.vue?vue&type=script&lang=js"
export * from "./NyuukaPlanPage.vue?vue&type=script&lang=js"

import "./NyuukaPlanPage.vue?vue&type=style&index=0&id=71082aca&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__